import React, { useState } from 'react'; 
import './blog-post.css'; 
import './blog-slides.css';  
//pictures here
import recap1 from './pictures/serviceday1.jpeg';  
import recap2 from './pictures/serviceday2.jpeg'; 

const Clean = () => {
  return (
    <div>
      <div className='blog__container'>
        <div className="row">
          <div className="column">
            <header>
              <h3 className="site-post-title rounded title-padding">
                <b>WiC at Work</b>
              </h3>
            </header>
            <section>
              <h2>WiC x Clean Power Research Office Trek!</h2>
              <p className="site-post-meta">April 29, 2025</p>
              <hr />
            </section>
            <section>
              <p>

              Hi WiC!

<br></br>
<br></br>

Thank you to everyone who joined us for our visit to the Clean Power Research office in Bellevue! We had a fantastic time connecting with a wide range of women professionals across the company, including technical program managers, software engineers, product managers, research analysts, data quality engineers, and members of the HR team.

<br></br>
<br></br>

The event gave us the chance to ask questions, network, and gain real insight into the day-to-day experiences of women working in tech. One of the highlights of the visit was getting to meet the CEO during a surprise appearance at the end of the session, which was an amazing opportunity to hear his perspective and ask questions directly.

<br></br>
<br></br>

We also enjoyed breakfast and a guided tour of the office, while getting to know more about Clean Power Research's mission, values, and workplace culture. It was a valuable experience that we hope left those who attended feeling inspired and informed about potential career paths and a chance to connect with other Allen School students!

<br></br>
<br></br>

This certainly will not be the last opportunity to connect with Clean Power Research! Keep an eye out for their attendance at career fairs next year and future WiC events with Clean Power Research.
                
              </p>
              <img src={recap2} alt="Recap 1" />
              <img src={recap1} alt="Recap 2" />
              
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clean;